const UNIT_LISTING_FIELDS = Object.freeze({
  rent: "rent",
  securityDeposit: "securityDeposit",
  unitAvailableOn: "unitAvailableOn",
  note: "note",
});

export { UNIT_LISTING_FIELDS };
